import React from 'react';
import GoogleAdSense from '../components/GoogleAdSense';

export default (
  array: { content: JSX.Element; isAd?: boolean }[],
  {
    keyPrefix,
    className,
    slot,
    layout,
    format,
    responsive,
    style,
    wrap,
  }: {
    keyPrefix?: string;
    className?: string;
    slot: string;
    layout?: 'in-article' | 'in-feed' | 'image';
    format?: 'fluid' | 'auto';
    responsive?: boolean;
    style?: React.CSSProperties;
    wrap?: (inner: React.ReactNode) => JSX.Element;
  },
) => {
  if (array.length > 0 && process.env.GATSBY_CA_PUB_ID) {
    let amount = 0;
    for (
      let i = 1;
      i < array.length && amount < 3;
      i += Math.round(i * 0.6 + 4)
    ) {
      const ad = (
        <GoogleAdSense
          key={`${keyPrefix || ''}ad-${i}`}
          client={process.env.GATSBY_CA_PUB_ID}
          {...{ className, slot, layout, format, responsive, style }}
        />
      );

      array.splice(i, 0, {
        content: <>{(wrap && wrap(ad)) || ad}</>,
        isAd: true,
      });

      amount += 1;
    }
  }

  return array;
};
